import { render, staticRenderFns } from "./quiz-index.vue?vue&type=template&id=76d2a6ec&"
import script from "./quiz-index.vue?vue&type=script&lang=js&"
export * from "./quiz-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports